import React, { useEffect, useState, forwardRef } from 'react';
import './Navbar.css'
import { useLocation } from 'react-router-dom';
// import logo from 'assets/images/logos/hope_bible_church.png'
import MobileNavbar from './MobileNavbar/MobileNavbar';
import DesktopNavbar from './DesktopNavbar/DesktopNavbar';


const Navbar = forwardRef<HTMLDivElement, {}>((props, ref) => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 980);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, [])

  const navLinks = [
    {
      path: '/', label: 'Home'
    },
    { path: '/introduction', label: 'Read' },
    {
      path: '/download', label: 'Download'
    },
    { path: '/about', label: 'About the Author' },
    { path: '/totd', label: 'Thought of the Day' }
  ]

  const logo = "Overcoming Temptation"
  const subLogo = "Biblical Principles for Daily Victory"

  return (
    <div ref={ref} className='navbar'>
      {isMobile ?
        <MobileNavbar logo={logo} subLogo={subLogo} links={navLinks} /> :
        <DesktopNavbar logo={logo} subLogo={subLogo} links={navLinks} />}
    </div>

  );
});

export default Navbar;
